module.exports = __webpack_public_path__ + "img/PG.795027f6.webp";